import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnalyticsGraphBar1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "analytics-graph-bar-1" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 23.25,
			x2: 23.25,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6,17.25H3a.75.75,0,0,0-.75.75v5.25h4.5V18A.75.75,0,0,0,6,17.25Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M13.5,9.75h-3a.75.75,0,0,0-.75.75V23.25h4.5V10.5A.75.75,0,0,0,13.5,9.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21,14.25H18a.75.75,0,0,0-.75.75v8.25h4.5V15A.75.75,0,0,0,21,14.25Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 2.25,
			cy: 10.5,
			r: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 9,
			cy: 2.25,
			r: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 21.75,
			cy: 6,
			r: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.2,
			y1: 9.339,
			x2: 8.05,
			y2: 3.411
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 20.311,
			y1: 5.576,
			x2: 10.439,
			y2: 2.673
		})
	]
});
export default SvgAnalyticsGraphBar1;
